import React from 'react';
import './menu-toggle.scss';

export type MenuToggle = {
  toggle: () => void;
}

export const MenuToggle: React.FC<MenuToggle> = ({ toggle }) => (
  <button
    type="button"
    className="menu-toggle"
    onClick={toggle}
  >
    <span className="cross" />
    <span className="cross" />
  </button>
);
